<template>
  <IQOS
    class="gap-row-xs"
    :title="iqosSetupTitle"
    :backgroundColor="bgColor"
    :overrideDividerColor="mode == 'inside' ? 'v1-grey-3' : null"
    required
  >
    <template #title>
      <span
        class="bold"
        :class="{
          light: mode == 'inside',
        }"
        >{{ iqosSetupTitle }}</span
      >
    </template>

    <div
      class="setup-items gap-row-1xs"
      :class="{
        light: mode == 'inside',
      }"
    >
      <template v-for="(v, k) in readyness.items">
        <div class="setup-item gap-column-1xs" :key="k + v">
          <div
            class="setup-item-circle"
            :class="{ active: v, light: mode == 'inside' }"
          >
            <BaseIcon icon="check" class="setup-item-check" />
          </div>
          <div class="qrw-paragraph-md setup-item-text w-100">
            {{ $t("mode_settings_hints." + k) }}
          </div>
          <BaseButton
            v-if="!v"
            class="setup-btn"
            size="sm"
            :color="mode == 'inside' ? 'v1-grey-3' : 'v1-grey-10'"
            variant="secondary"
            @click="goToSetup(k)"
          >
            {{ $t("quickstart_setup.setup_btn") }}
          </BaseButton>
        </div>
        <BaseDivider
          dashed
          :color="dividerColor"
          :key="k"
          v-if="k !== lastReadyKey"
        />
      </template>
    </div>

    <template #actions>
      <div
        class="status-text qrw-paragraph-md"
        :class="{
          'v1-grey-10-color': mode !== 'inside',
          'v1-grey-1-color': mode == 'inside',
        }"
        v-if="!readyness.total"
      >
        {{ $t("quickstart_setup.pending") }}
      </div>
      <div
        class="status-text qrw-paragraph-md"
        :class="{
          'v1-grey-10-color': mode !== 'inside',
          'v1-grey-1-color': mode == 'inside',
        }"
        v-html="
          $t('quickstart_setup.ready', {
            system: iqosSetupTitle,
          })
        "
        v-else
      ></div>
    </template>
  </IQOS>
</template>

<script>
export default {
  props: {
    mode: String,
  },
  methods: {
    goToSetup(key) {
      const route =
        {
          menu: "menus",
          schedule: "general",
          tables: "halls",
        }[key] || this.mode;

      this.$router.push(route);
    },
  },
  computed: {
    bgColor() {
      return {
        inside: "v1-grey-10",
        delivery: "blue-2",
        preorder: "yellow-3",
        reserve: "green-1",
        preview: "v1-grey-2",
      }[this.mode];
    },
    dividerColor() {
      return {
        inside: "v1-grey-8",
        delivery: "blue-3",
        preorder: "yellow-5",
        reserve: "green-3",
        preview: "v1-grey-4",
      }[this.mode];
    },
    iqosSetupTitle() {
      return {
        inside: "INSIDE",
        delivery: "DELIVERY",
        preorder: "TAKEAWAY",
        reserve: "RESERVE",
        preview: "PREVIEW",
      }[this.mode];
    },
    readyness() {
      const key =
        this.mode.substring(0, 1).toUpperCase() + this.mode.substring(1);

      const value = Object.assign({}, this.$store.getters[`ready${key}`]);
      const total = value.total;

      delete value.total;
      delete value.subtotal;

      return {
        items: value,
        total,
      };
    },
    lastReadyKey() {
      return Object.keys(this.readyness.items).pop();
    },
  },
};
</script>

<style scoped>
.setup-item-circle {
  border-radius: 50%;
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;

  border: 1px solid var(--v1-grey-10-color);
}

.setup-item-text {
  align-items: center;
  align-self: center;
}

.setup-item-circle.active {
  background: var(--v1-grey-10-color);
  color: var(--v1-grey-3-color);
}

.setup-item-circle.light {
  background: var(--v1-grey-10-color);
  color: var(--v1-grey-3-color);
}

.setup-item-circle.light.active {
  background: var(--v1-grey-3-color);
  color: var(--v1-grey-10-color);
}

.setup-items {
  padding: 0 8px;
}

.light {
  color: var(--v1-grey-3-color);
}

.status-text {
  width: 100%;
  text-align: right;
}

.setup-item-check {
  font-size: 8px !important;
}

.setup-btn {
  min-width: fit-content;
}
</style>
